/*
  ADA / WCAG 4.1.2 (2026-09-30): accordion toggles for the checkbox-hack
  accordions (faqs_new, collection-seo-copy, clinical-studies-pdp/hp).

  The visible control is a <button class="tab-label" data-faq-toggle="<id>"
  aria-expanded aria-controls>. The hidden checkbox with that id still drives
  the open/closed CSS (:checked selectors), so the styling is untouched; the
  button just flips the checkbox and mirrors its state into aria-expanded.
  Screen readers now hear "button, collapsed/expanded" instead of "checkbox".
*/
(function () {
  function sync(button, input) {
    button.setAttribute('aria-expanded', input.checked ? 'true' : 'false');
  }

  function init(root) {
    var buttons = (root || document).querySelectorAll('button[data-faq-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var input = document.getElementById(buttons[i].getAttribute('data-faq-toggle'));
      if (input) sync(buttons[i], input);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button[data-faq-toggle]');
    if (!button) return;
    var input = document.getElementById(button.getAttribute('data-faq-toggle'));
    if (!input) return;
    input.checked = !input.checked;
    sync(button, input);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
